import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const OfflineDevicesAlert = () => {
    const devices = useSelector((state) => state.devices.items);
    const user = useSelector((state) => state.session.user);

    const userId = user?.id;
    const isAdmin = user?.administrator;

    const [open, setOpen] = useState(false);
    const [staleDevices, setStaleDevices] = useState([]);

    // Sobrevive a los re-renders de este componente (por ejemplo, cada vez
    // que llega una actualizacion de "devices" por el socket)
    const checkedRef = useRef(false);

    useEffect(() => {
        // Sin usuario todavia, o el usuario es administrador: no evaluamos ni mostramos
        if (!userId || isAdmin) {
            return;
        }

        const storageKey = `offlineDevicesAlertShown_${userId}`;

        // Ya se evaluo en esta sesion (memoria) o en esta pestana (sessionStorage)
        if (checkedRef.current || sessionStorage.getItem(storageKey)) {
            return;
        }

        const deviceList = Object.values(devices || {});
        // Esperamos a que el store ya tenga dispositivos cargados
        if (deviceList.length === 0) {
            return;
        }

        // Marcamos como "ya evaluado" ANTES de calcular, asi aunque
        // devices vuelva a cambiar, este bloque no se vuelve a ejecutar
        checkedRef.current = true;
        sessionStorage.setItem(storageKey, '1');

        const now = Date.now();
        const stale = deviceList.filter((device) => {
            if (!device.lastUpdate) return true;
            const last = new Date(device.lastUpdate).getTime();
            return now - last > ONE_DAY_MS;
        });

        if (stale.length > 0) {
            setStaleDevices(stale);
            setOpen(true);
        }
    }, [devices, userId, isAdmin]);

    const handleClose = () => setOpen(false);

    if (!open) return null;

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>Unidades sin reportar</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    Las siguientes unidades llevan más de 24 horas sin reportar su posición.
                    Si sabes que estas unidades siguen en operación, te recomendamos
                    ponerte en contacto con soporte para revisar el equipo instalado.
                </DialogContentText>
                <List dense disablePadding>
                    {staleDevices.map((device) => (
                        <React.Fragment key={device.id}>
                            <ListItem disableGutters>
                                <ListItemText
                                    primary={device.name}
                                    secondary={`Último reporte: ${device.lastUpdate
                                            ? new Date(device.lastUpdate).toLocaleString()
                                            : 'Sin datos'
                                        }`}
                                />
                            </ListItem>
                            <Divider component="li" />
                        </React.Fragment>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Entendido
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OfflineDevicesAlert;